namespace advisorop.components.investor {

    class InvHhDashboardController {

        $router;
        public household: domains.IHousehold;

        public householdId: number;
        showClosedInactive: boolean = false;
        hideSleeves: boolean = true;

        // inputs for account summary grid
        public accounts: any[];
        noAssetAllocHistAccounts;
        public insuranceAccounts: any[] = [];
        public annuityAccounts: any[] = [];
        public accountGroupType: domains.AccountGroupType = domains.AccountGroupType.RTG;
        mvDate: Date = null;
        public accountsWithHoldingsInfo: any[];
        showAssetAllocation = 1;
        chartData: Array<domains.IChartDataSource>;
        // For investors, historical charts is enabled per investor
        invLoginOptionAllowHistChartsGroups: boolean = false;
        invLoginOptionAllowHistChartsAccts: boolean = false;
        allowHistCharts: boolean = false;
        histChartView: boolean = false;
        histChrData = [];
        histChartData = []
        histChartType: string = "1";
        histChartDateType: string = "1";
        chartHDAccountsController: advisorop.components.widgets.ChartHdAccountsController;
        hdg: DevExpress.ui.dxDataGridOptions;
        asg: InvAccountSummaryGridController;
        acctDropdownPrepared: boolean = false;


        // PP and Orion direct API Access
        ppParams: { pplevel: string, ppclientid: string }; // ppclientid: 4918    U-DEMO04   DEMO01 | pplevel:  HH CG AC

        public investor: domains.IInvestor;
        public investorAdvisor: domains.IAdvisor;

        chartDataParams: {
            level?: string,
            householdId?: number,
            accountGroupType?: number,
            groupId?: number,
            accountId?: number,
            boModelId?: number,
            showClosedInactive?: boolean,
            additionalData?: string
        }

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#invHouseholdContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        chartDataLoading: boolean = false;
        chartLoadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#invHouseholdChartContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Retrieving data...",
            bindingOptions: {
                visible: "vm.chartDataLoading"
            }
        }

        helpPopupOptions: DevExpress.ui.dxPopoverOptions = {
            target: "#invHHDashHelp",
            showEvent: "mouseenter",
            hideEvent: "mouseleave",
            position: "left",
            width: 400,
            animation: {
                show: { type: "pop", from: { scale: 0 }, to: { scale: 1 } },
                hide: { type: "fade", from: 1, to: 0 }
            },
            showTitle: true,
            title: "Account Values Widget",
            visible: false
        }

        ctlAccountDdl: advisorop.components.common.AccountsDdlController;

        static $inject = ["investorService", `householdApi`, `investorDashboardService`, `acgHelper`, `generalService`];
        constructor(
            private invSrv: services.InvestorService,
            private hhApi: services.HouseholdApi,
            private ids: services.InvestorDashboardService,
            private acgs: services.AcgHelper,
            private gs: services.GeneralService
        ) {
            this.chartData = this.ids.getEmptyChartData();
            this.histChartData = [];
            this.chartDataParams = {
                level: null,
                householdId: null,
                accountGroupType: null,
                groupId: null,
                accountId: null,
                boModelId: null,
                showClosedInactive: null,
                additionalData: null
            };
            this.hdg = {
                export: {
                    enabled: false,
                    fileName: "NoAssetAllocHistAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.noAssetAllocHistAccounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There are no accounts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountName', caption: 'Account name', cellTemplate: 'colFullName2' }
                ]
            };
        }

        onChangeAccountGroupType() {
            this.ctlAccountDdl.selItemID = "Nothing selected...";
            this.ctlAccountDdl.selItemData = null;

            if (this.isInitializing == false)
                this.loadHDAccounts();
        };

        asg_onReady = (component) => {
            //console.log("onReady", component);
            this.asg = component;
        }

        hideAssetAllocationPanelAndEmptyData = () => {
            console.log("There are no charts...");
            this.showAssetAllocation = 0;
            this.ctlAccountDdl.selItemID = "no data";
            this.ctlAccountDdl.selItemData = null;
            this.chartData = this.ids.getEmptyChartData();
        }

        // Updates the structure in place
        setVisibilityOfData(dataSet: Array<domains.IStackedBarChartDataset>, histChartType: string) {
            if (histChartType == "1" || histChartType == "2") {
                // percentage or value based = show all
                dataSet.forEach(function (r, a) {
                    if (r)
                        r.visible = "1";
                });
            } else if (histChartType == "3") {
                // Hide Value Line
                dataSet.forEach(function (r, a) {
                    if (r) {
                        if (r.seriesname == "Total Value")
                            r.visible = "0";
                        else
                            r.visible = "1";
                    }
                });
            } else if (histChartType == "4") {
                // Show Value Line Only
                dataSet.forEach(function (r, a) {
                    if (r) {
                        if (r.seriesname == "Total Value")
                            r.visible = "1";
                        else
                            r.visible = "0";
                    }
                });
            }
        }

        toggleDataVisibility() {
            // show or hide the line chart data based on the options selected by the user. 
            this.histChrData.forEach(v => { if (v.dataset && v.dataset.length > 0) this.setVisibilityOfData(v.dataset, this.histChartType); });
        }

        setStackPercentAttribute() {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.setChartAttributes(this.histChartType);
            }
        }

        // Sum across like indexes for each series to compute the total for each series and
        // return the line-chart series definition that we can append to the chart dataset structure.
        createLineChartDataset(dataSet: Array<domains.IStackedBarChartDataset>): domains.IStackedBarChartDataset {

            // Initialize an empty chart dataset data structure
            let chartDatasetData: Array<domains.ChartDatasetData> = [];
            if (dataSet && dataSet.length > 0 && dataSet[0].data && dataSet[0].data.length > 0) {
                dataSet[0].data.forEach(f => {
                    var d: domains.ChartDatasetData = { value: 0 };
                    chartDatasetData.push(d);
                });
                // Populate the structure, summing across all of the series
                dataSet.forEach(function (r, a) {
                    r.data.forEach(function (b, i) {
                        chartDatasetData[i].value = (chartDatasetData[i]?.value || 0) + b.value;
                    });
                });
                // Return dataset, specified as line plot
                const ret: domains.IStackedBarChartDataset = {
                    seriesname: "Total Value",
                    renderas: "Line",
                    showvalues: "1",
                    data: chartDatasetData
                };

                return ret;
            }
            return null;
        }

        updateHistChartData() {
            if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                this.histChartData = [];
                //console.log("HISTCHRDATA", this.histChrData);
                angular.copy(this.histChrData, this.histChartData);
            }
        }

        bindChartHDAccountsWidget(ctrl: advisorop.components.widgets.ChartHdAccountsController) {
            this.chartHDAccountsController = ctrl;
            this.setStackPercentAttribute();
        }

        loadSelectedChartData() {

            this.chartDataLoading = true;

            var dateTypeParam: domains.HistChartDateType;
            if (this.histChartDateType == "1")
                dateTypeParam = domains.HistChartDateType.LAST_SIX_MONTHS;
            else if (this.histChartDateType == "2")
                dateTypeParam = domains.HistChartDateType.LAST_FOUR_QUARTERS;
            else
                dateTypeParam = domains.HistChartDateType.LAST_ONE_WEEK;

            //const getHdChartPromise = this.ids.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, this.histChartView, dateTypeParam);
            //
            //// load HD chart data
            //if (getHdChartPromise != null) {
            //    getHdChartPromise.then(response => {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.clearHistChartData = true;
                this.histChartData = [];
            }
            this.ids.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, (this.histChartView && this.allowHistCharts), dateTypeParam)
                .then(response => {
                    if (!response || !response.data || !response.data.chartData || response.data.chartData.length <= 0) {
                        this.hideAssetAllocationPanelAndEmptyData();
                    } else {
                        this.showAssetAllocation = 1;
                        this.chartData = response.data.chartData;
                        this.chartData.forEach(v => v.chart.caption = this.chartDataParams.additionalData);
                        if (this.histChartView && this.allowHistCharts) {
                            this.histChrData = response.data.histChartData;
                            if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                                // Create line chart dataset for the totals
                                this.histChrData.forEach(v => v.dataset?.push(this.createLineChartDataset(v.dataset)));
                                if (this.chartHDAccountsController)
                                    this.chartHDAccountsController.histChartDataExists = true;
                                this.toggleDataVisibility();
                                this.updateHistChartData();
                            } else {
                                if (this.chartHDAccountsController)
                                    this.chartHDAccountsController.histChartDataExists = false;
                            }
                        }
                    }
                }).finally(() => {
                    this.chartDataLoading = false;
                });
        }

        histChartsToggle(toggle: boolean) {
            //console.log("In Hist Charts toggle")
            //console.log("this.invLoginOptionAllowHistChartsGroups", this.invLoginOptionAllowHistChartsGroups)
            //console.log("this.invLoginOptionAllowHistChartsAccts", this.invLoginOptionAllowHistChartsAccts)
            //console.log("this.chartDataParams.level", this.chartDataParams.level)

            // Check if user is allowed to see historical charts for this level
            if (this.chartDataParams && ((this.invLoginOptionAllowHistChartsGroups && (this.chartDataParams.level == "H" || this.chartDataParams.level == "R"))
                || (this.invLoginOptionAllowHistChartsAccts && (this.chartDataParams.level == "A" || this.chartDataParams.level == "S")))) {
                // Hist charts are allowed
                this.allowHistCharts = true;
            } else {
                // Hist charts are not allowed, do not show
                this.allowHistCharts = false;
            }
        }

        hg_onItemSelected(item, level, additionalData) {

            this.invSrv.selHDItem = item;
            this.invSrv.selHDLevel = level;

            // when account is changed we need to calculate "PpLevel" and "PpClientId"", which we need for a PP and Orion reports
            this.ppParams = this.ids.calculatePpLevelAndClientId(level, item.boRtgId, item.boCustodialAccountNumber, item.boUMAAccountIdentifierString);

            //console.log("hg_onItemSelected: level:", level);
            //console.log("hg_onItemSelected: item:", item);
            //console.log("ppParams:", this.ppParams);
            //: ${ item.groupId }, account: ${ item.accountId }, sleeve: ${ item.boModelId }`);

            this.chartDataParams.level = level;
            this.chartDataParams.householdId = this.householdId;
            this.chartDataParams.accountGroupType = this.accountGroupType;
            this.chartDataParams.groupId = item.groupId;
            this.chartDataParams.accountId = item.accountId;
            this.chartDataParams.boModelId = item.boModelId;
            this.chartDataParams.showClosedInactive = this.showClosedInactive;
            this.chartDataParams.additionalData = additionalData;

            if (level == "H") {
                this.ctlAccountDdl.setSelItemId(this.householdId);
                this.histChartsToggle(true);
            }
            else if (level == "R") {
                this.ctlAccountDdl.setSelItemId(`${this.householdId}_${item.groupId}`);
                this.histChartsToggle(true);
            }
            else if (level == "A") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }
            else if (level == "S") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }

            this.loadSelectedChartData();
            //else {
            //// OA - outside investment accounts where holdings are maintained outside of AdvisorOp,
            //// we can not show asset allocation for these because they all share the same Security ID
            //this.hideAssetAllocationPanelAndEmptyData();
            //if (item.boModelId > 0) {
            //    this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
            //} else {
            //    this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
            //}
            //}
        }

        loadInvestor() {
            this.invSrv.getInvestor().then(data => {
                this.investor = data.data;

                // Set investor login option to be able to view historical asset allocation charts at the group level
                if (this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL).length > 0) {
                    this.invLoginOptionAllowHistChartsGroups = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL)[0].value == 1;
                }
                // Set investor login option to be able to view historical asset allocation charts at the account level
                if (this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL).length > 0) {
                    this.invLoginOptionAllowHistChartsAccts = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL)[0].value == 1;
                }
                // Initialize to whatever the group level permission is
                this.allowHistCharts = this.invLoginOptionAllowHistChartsGroups;

                //
                // FOR NOW NO INVESTORS WILL HAVE POINT TO POINT PERFORMANCE. GL Aug 2019
                //
                //if (this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_POINT_TO_POINT_PERFORMANCE).length > 0) {
                //    this.showPointToPoint = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_POINT_TO_POINT_PERFORMANCE)[0].value == 1;
                //}
            }, err => this.gs.showError(err));
        }

        loadInvestorAdvisor() {
            this.invSrv.getInvestorAdvisor().then(data => {
                this.investorAdvisor = data.data;
                //console.log("DATADATA", data.data);
            }, err => this.gs.showError(err));
        }

        $onInit(): void {
            this.loadInvestor();
            this.loadInvestorAdvisor();
        }

        loadHDAccounts(): void {
            this.mvDate = null;
            this.isInitializing = true;
            this.hhApi.getAccountGroupsSummary(this.householdId, this.accountGroupType, this.showClosedInactive)
                .then((data) => {
                    this.accounts = data.data.gridData;
                    if (this.accounts.length > 0) {
                        // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                        this.mvDate = this.accounts[0].marketValueDate;
                    }
                    //this.insuranceAccounts = data.data.insuranceAccounts;
                    //this.annuityAccounts = data.data.annuityAccounts;
                    this.insuranceAccounts = [];
                    this.annuityAccounts = [];
                    if (data.data.hasOwnProperty('insuranceAccounts') && data.data.insuranceAccounts.length > 0)
                        this.insuranceAccounts = data.data.insuranceAccounts;
                    if (data.data.hasOwnProperty('annuityAccounts') && data.data.annuityAccounts.length > 0)
                        this.annuityAccounts = data.data.annuityAccounts;

                    // preparing data structure for DropDown-TreeView content
                    if (this.ctlAccountDdl) {
                        this.acctDropdownPrepared = true;
                        //console.log("PREPARING DROPDOWN DATA!!!!!!BBBBB", this.accounts);
                        this.ctlAccountDdl.prepareDropDownData(this.accounts);
                    } else {
                        //console.log("NOT PREPARING DROPDOWN DATA!!!!!!BBBBB");
                    }

                    if (!data.data || !data.data.charts || data.data.charts.length <= 0) {
                        // hide asset allocation
                        this.hideAssetAllocationPanelAndEmptyData();

                        this.isInitializing = false;

                        return;
                    }

                    this.noAssetAllocHistAccounts = this.accounts.filter(f => f.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && f.manualHoldingsExSystem == false);

                    this.chartData = data.data.charts;

                    // Save the current state so that if the user elects to see historical charts
                    // we can load them using the current state
                    this.chartDataParams.level = "H";
                    this.chartDataParams.householdId = this.householdId;
                    this.chartDataParams.accountGroupType = this.accountGroupType;
                    this.chartDataParams.groupId = null;
                    this.chartDataParams.accountId = null;
                    this.chartDataParams.boModelId = null;
                    this.chartDataParams.showClosedInactive = this.showClosedInactive;
                    this.chartDataParams.additionalData = this.household.name + " - Household Level";

                    // this mean that HH must be loaded ...
                    if (this.household)
                        this.chartData.map(v => v.chart.caption = this.chartDataParams.additionalData);

                    this.accountsWithHoldingsInfo = data.data.holdings;
                    this.isInitializing = false;
                });
        };

        loadHousehold(householdId: number): ng.IPromise<domains.IHousehold> {
            this.isInitializing = true;
            return this.invSrv.getHousehold(householdId)
                .then(response => {
                    this.household = response.data;
                    //console.log("HOUSEHOLD:",this.household);
                    this.isInitializing = false;
                    return this.household;
                }, err => this.gs.showError(err));
        }

        onAccountsDdlItemSelected = (itemData) => {
            //console.log("AdvisorHouseholdDashboard: onAccountsDdlItemSelected received... itemData:", itemData);
            if (itemData) {
                // clear selection in HH grid
                $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                    $(elm).removeClass("acsrow");
                });

                // selecting row in dgHouseholds grid
                const dgSummary = DevExpress.ui.dxDataGrid.getInstance($("#dgHouseholds")) as DevExpress.ui.dxDataGrid;

                //SYNC selection on SummaryGrid
                this.acgs.syncDgSummaryGridSelection(itemData.level, itemData.item, this.asg.sortByField, this.asg.rootLevel, dgSummary, this.accounts);

                //let dgSummaryRowIndex;
                //if (itemData.ID == this.householdId) {
                //    dgSummaryRowIndex = 0;
                //} else if (itemData.level == "S") {
                //    // console.log("HH row key", itemData.item);
                //    // first we need to ensure that row is expanded
                //    const dgSummaryRowKey = [this.householdId, itemData.item.groupId, itemData.item.accountId]
                //        .map(m => +m);
                //    dgSummary.expandRow(dgSummaryRowKey).then(vv => {
                //        dgSummaryRowIndex = dgSummary.getRowIndexByKey(itemData.item);
                //        if (dgSummaryRowIndex >= 0) {
                //            const rowEl = dgSummary.getRowElement(dgSummaryRowIndex);
                //            $(rowEl).addClass("acsrow");
                //        }
                //    }, err => console.log(`Error during ExpandRow of dgHouseholds widget...`));
                //} else if (itemData.level == "R") {
                //    const dgSummaryRowKey: any[] = (itemData.ID as string).split("_").map(m => +m);
                //    dgSummaryRowIndex = dgSummary.getRowIndexByKey(dgSummaryRowKey);
                //} else {
                //    const dgSummaryRowKey: any[] = [`${this.householdId}`]
                //        .concat((itemData.ID as string).split("_"))
                //        .map(m => +m);
                //    dgSummaryRowIndex = dgSummary.getRowIndexByKey(dgSummaryRowKey);
                //}
                //if (dgSummaryRowIndex >= 0) {
                //    const rowEl = dgSummary.getRowElement(dgSummaryRowIndex);
                //    $(rowEl).addClass("acsrow");
                //}

                //console.log(`HH row index is:`, dgSummaryRowIndex);
                this.hg_onItemSelected(itemData.item, itemData.level, itemData.caption);
            }
        }

        onChangeHistView() {
            if (this.histChartView && !this.isInitializing)
                this.loadSelectedChartData();
        }

        onChangeHistChartType() {
            this.setStackPercentAttribute();
            this.toggleDataVisibility();
            this.updateHistChartData();
        }

        onChangeHistChartDateType() {
            if (!this.isInitializing)
                this.loadSelectedChartData();
        }

        onAccountsDdlReady = (ctrl) => {
            this.ctlAccountDdl = ctrl;
            if (this.accounts != undefined && this.accounts != null && this.acctDropdownPrepared == false) {
                //console.log("PREPARING DROPDOWN DATA!!!!!!AAAAA", this.accounts);
                this.acctDropdownPrepared = true;
                this.ctlAccountDdl.prepareDropDownData(this.accounts);
            } else {
                //console.log("NOT PREPARING DROPDOWN DATA!!!!!!AAAAA");
            }
        }

        $routerOnActivate(next, previous) {
            this.householdId = <number>next.params.householdId;
            //console.log(`Investor HH dashboard: ${this.householdId}`);

            this.loadHousehold(this.householdId).then(hh => {
                if (this.household.defaultAccountGroupView == domains.AccountGroupView.ADG) {
                    this.accountGroupType = domains.AccountGroupType.ADVISOR_DEFINED;
                } else {
                    this.accountGroupType = domains.AccountGroupType.RTG;
                }
                this.loadHDAccounts();
            }, err => this.gs.showError(err));


        }
    }


    class InvHhDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = InvHhDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/investor-module/components/inv-hh-dashboard.html';
        }
    }
    angular.module(Constants.APP).component("invHhDashboard", new InvHhDashboard());


}